import keyMirror from 'keymirror-nested'

export default keyMirror({
  SHIPMENT_LIST: {
    UPDATE: {
      SELECTED_RATE: null,
      STATUS: null,
    },
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
